/**
 * Lightweight analytics tracking for Staffera.
 * Sends events to backend for funnel analysis.
 * Never stores personal data beyond UTM attribution.
 */
import api from "./api";

export function trackEvent(eventName, data = {}, explicitUtm = null) {
  try {
    // Use explicit UTM if provided, otherwise read from sessionStorage
    let utm = explicitUtm;
    if (!utm) {
      const utmRaw = sessionStorage.getItem("staffera_utm");
      utm = utmRaw ? JSON.parse(utmRaw) : {};
    }
    api.post("/analytics/event", {
      event: eventName,
      data,
      utm,
    }).catch(() => {}); // Fire and forget — never block UI
  } catch {
    // Silent fail — analytics should never break the app
  }
}

export function getStoredUTM() {
  try {
    const raw = sessionStorage.getItem("staffera_utm");
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/**
 * Extract UTM params from URLSearchParams and persist to sessionStorage.
 * Returns the UTM object so callers can pass it to trackEvent immediately.
 */
export function captureUTM(searchParams) {
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const utms = {};
  utmKeys.forEach(k => { const v = searchParams.get(k); if (v) utms[k] = v; });
  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem("staffera_utm", JSON.stringify(utms));
  }
  return utms;
}
